export default () => ({
  init() {
    this.store = Alpine.store("data")

    this.store.values.privacyAgreement = false

    window.addEventListener("pageshow", (event) => {
      // Always reset on init according to requirements
      this.store.values.privacyAgreement = false

      // Set input checked state manually, to avoid out-of-sync
      // behavior when browser renders cached page (when going back)
      const privacyAgreementInput = document.getElementById("privacyAgreementInput")
      privacyAgreementInput.checked = this.store.values.privacyAgreement
    })
  },

  togglePrivacyAgreement($event) {
    this.store.values.privacyAgreement = $event.target.checked
    
    if ($event.target.checked) {
      this.store.internalTracker.trackClick({ clickName: "Policy Agreement Checked" })
    }
  },

  getValueFromPipelineConfig(key) {
    return pipelineConfig[key]
  },
})
